(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-canvas-product"] && !Shopify.designMode) return;
  try {
    
/* Bonne et Filou product enhancement. Purchasing uses the native Shopify form. */
(() => {
  'use strict';
  if (window.bfCanvasProductInitialized) return;
  window.bfCanvasProductInitialized = true;

  function initialize(root) {
    if (root.dataset.bfInitialized === 'true') return;
    root.dataset.bfInitialized = 'true';

    const variantSelect = root.querySelector('[data-bf-variant]');
    const quantity = root.querySelector('[data-bf-quantity]');
    const addButton = root.querySelector('[data-bf-add]');
    const price = root.querySelector('[data-bf-price]');
    const compare = root.querySelector('[data-bf-compare]');
    const image = root.querySelector('.bf-gallery__image');
    const mainLink = root.querySelector('[data-bf-main-link]');
    const thumbnails = Array.from(root.querySelectorAll('[data-bf-thumbnail]'));
    const quantityButtons = Array.from(root.querySelectorAll('[data-bf-quantity-change]'));
    const optionPanel = root.querySelector('[data-bf-options]');
    const optionGroups = Array.from(root.querySelectorAll('[data-bf-option-group]'));
    const variantOptions = variantSelect ? Array.from(variantSelect.options) : [];

    function selectedValues() {
      return optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
    }

    function matchingVariant(values) {
      return variantOptions.find((option) => values.every((value, index) => option.getAttribute(`data-option-${index + 1}`) === value));
    }

    function updateOptionAvailability() {
      const selected = selectedValues();
      optionGroups.forEach((group, index) => {
        group.querySelectorAll('[data-bf-option]').forEach((input) => {
          const candidate = selected.slice();
          candidate[index] = input.value;
          const match = matchingVariant(candidate);
          const unavailable = !match || match.dataset.available !== 'true';
          const label = input.closest('.bf-option');
          label.classList.toggle('is-unavailable', unavailable);
          if (unavailable) label.title = 'Unavailable with the current choices';
          else label.removeAttribute('title');
        });
      });
    }

    function showImage(thumbnail) {
      if (!image || !thumbnail) return;
      image.srcset = thumbnail.dataset.srcset;
      image.src = thumbnail.dataset.src;
      image.alt = thumbnail.dataset.alt || '';
      image.width = Number(thumbnail.dataset.width);
      image.height = Number(thumbnail.dataset.height);
      if (mainLink) mainLink.href = thumbnail.href;
      thumbnails.forEach((item) => {
        if (item === thumbnail) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    }

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        showImage(thumbnail);
      });
    });

    function updateQuantityButtons() {
      if (!quantity) return;
      const current = Number(quantity.value);
      const minimum = Number(quantity.min || 1);
      const maximum = quantity.max ? Number(quantity.max) : Infinity;
      quantityButtons.forEach((button) => {
        const decrease = Number(button.dataset.bfQuantityChange) < 0;
        button.disabled = decrease ? current <= minimum : current >= maximum;
      });
    }

    function updateVariant(updateUrl) {
      const option = variantSelect?.selectedOptions[0];
      if (!option) {
        if (price) price.textContent = root.dataset.unavailableLabel;
        if (compare) compare.hidden = true;
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = root.dataset.unavailableLabel;
        }
        updateOptionAvailability();
        return;
      }
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      }
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        const minimum = Number(quantity.min);
        const maximum = quantity.max ? Number(quantity.max) : Infinity;
        const step = Number(quantity.step);
        const current = Number(quantity.value);
        if (!Number.isFinite(current) || current < minimum || current > maximum || (current - minimum) % step !== 0) {
          quantity.value = String(minimum);
        }
        updateQuantityButtons();
      }
      if (option.dataset.imageId) {
        showImage(thumbnails.find((thumbnail) => thumbnail.dataset.imageId === option.dataset.imageId));
      }
      optionGroups.forEach((group, index) => {
        const selectedValue = option.getAttribute(`data-option-${index + 1}`);
        group.querySelectorAll('[data-bf-option]').forEach((input) => { input.checked = input.value === selectedValue; });
      });
      updateOptionAvailability();
      if (updateUrl && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    variantSelect?.addEventListener('change', () => updateVariant(true));
    if (optionPanel && optionGroups.length && variantOptions.length) {
      optionPanel.hidden = false;
      const fallback = root.querySelector('[data-bf-variant-fallback]');
      if (fallback) fallback.hidden = true;
      optionPanel.addEventListener('change', (event) => {
        if (!event.target.matches('[data-bf-option]')) return;
        const match = matchingVariant(selectedValues());
        variantSelect.value = match?.value || '';
        updateVariant(Boolean(match));
      });
    }
    root.querySelector('.bf-form')?.addEventListener('submit', (event) => {
      if (!variantSelect?.selectedOptions[0] || variantSelect.selectedOptions[0].dataset.available !== 'true') event.preventDefault();
    });
    window.addEventListener('popstate', () => {
      if (!root.isConnected || !variantSelect) return;
      const requestedId = new URL(window.location.href).searchParams.get('variant');
      if (requestedId && Array.from(variantSelect.options).some((option) => option.value === requestedId)) {
        variantSelect.value = requestedId;
        updateVariant(false);
      }
    });

    quantityButtons.forEach((button) => {
      button.hidden = false;
      button.addEventListener('click', () => {
        if (!quantity) return;
        const minimum = Number(quantity.min || 1);
        const maximum = quantity.max ? Number(quantity.max) : Infinity;
        const step = Number(quantity.step || 1);
        const direction = Number(button.dataset.bfQuantityChange);
        const current = Number(quantity.value) || minimum;
        quantity.value = String(Math.min(maximum, Math.max(minimum, current + direction * step)));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    quantity?.addEventListener('input', updateQuantityButtons);
    quantity?.addEventListener('change', updateQuantityButtons);

    const photoInput = root.querySelector('[data-bf-photo]');
    const photoPreview = root.querySelector('[data-bf-photo-preview]');
    const photoImage = root.querySelector('[data-bf-photo-image]');
    const photoName = root.querySelector('[data-bf-photo-filename]');
    const removePhoto = root.querySelector('[data-bf-remove-photo]');
    let objectUrl;

    function revokePreview() {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = undefined;
    }

    photoInput?.addEventListener('change', () => {
      revokePreview();
      const file = photoInput.files?.[0];
      if (!photoPreview || !photoImage || !photoName) return;
      photoPreview.hidden = !file;
      photoImage.hidden = true;
      photoImage.removeAttribute('src');
      photoName.textContent = file?.name || '';
      if (file && /^image\/(jpeg|png|webp)$/i.test(file.type)) {
        objectUrl = URL.createObjectURL(file);
        photoImage.src = objectUrl;
        photoImage.hidden = false;
      }
    });
    photoImage?.addEventListener('error', () => { photoImage.hidden = true; });
    removePhoto?.addEventListener('click', () => {
      if (!photoInput) return;
      photoInput.value = '';
      photoInput.dispatchEvent(new Event('change', { bubbles: true }));
      photoInput.focus();
    });
    root.addEventListener('bf:cleanup', revokePreview);
    updateVariant(false);
  }

  function scan(container) {
    if (container.matches?.('[data-bf-product]')) initialize(container);
    container.querySelectorAll('[data-bf-product]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-bf-product]').forEach((root) => root.dispatchEvent(new Event('bf:cleanup')));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfa-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wire = (scope = document) => {
      scope.querySelectorAll('[data-faq-less]').forEach(button => {
        if (button.dataset.wired) return;
        button.dataset.wired = 'true';
        button.addEventListener('click', () => {
          const more = button.closest('[data-faq-more]');
          if (!more) return;
          more.open = false;
          more.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      });

      scope.querySelectorAll('[data-faq-list]').forEach(list => {
        const input = list.querySelector('[data-faq-input]');
        if (!input || input.dataset.wired) return;
        input.dataset.wired = 'true';

        const clear = list.querySelector('[data-faq-clear]');
        const count = list.querySelector('[data-faq-count]');
        const more = list.querySelector('[data-faq-more]');
        const items = [...list.querySelectorAll('[data-faq-item]')];

        /* Read once. The answers are rich text and normalising them on every
           keystroke would be work for nothing. */
        const haystacks = items.map(item => item.textContent.toLowerCase().replace(/\s+/g, ' '));

        /* Whether the fold was open before the search started, so clearing
           the box puts it back the way the reader left it. */
        let wasOpen = false;
        let searching = false;

        const apply = () => {
          const query = input.value.trim().toLowerCase();

          if (!query) {
            items.forEach(item => { item.hidden = false; });
            if (searching && more) more.open = wasOpen;
            searching = false;
            list.removeAttribute('data-searching');
            if (count) count.hidden = true;
            if (clear) clear.hidden = true;
            return;
          }

          if (!searching) {
            wasOpen = more ? more.open : false;
            searching = true;
          }
          list.setAttribute('data-searching', 'true');
          if (clear) clear.hidden = false;
          /* Everything folded away has to be reachable, or the filter would
             quietly hide its own matches. */
          if (more) more.open = true;

          let hits = 0;
          items.forEach((item, i) => {
            const match = haystacks[i].indexOf(query) !== -1;
            item.hidden = !match;
            if (match) hits++;
          });

          if (count) {
            count.hidden = false;
            count.textContent = hits === 0
              ? 'No question matches that. Try a shorter word, or use the contact link above.'
              : (hits === 1
                ? '1 question matches'
                : hits + ' of ' + items.length + ' questions match');
          }
        };

        input.addEventListener('input', apply);
        input.addEventListener('search', apply);
        if (clear) {
          clear.addEventListener('click', () => {
            input.value = '';
            apply();
            input.focus();
          });
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => wire());
    else wire();
    document.addEventListener('shopify:section:load', event => wire(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfa-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const guard = event => event.preventDefault();
    const protect = (scope = document) => {
      scope.querySelectorAll('[data-bfa-protected]').forEach(gallery => {
        if (gallery.dataset.protected) return;
        gallery.dataset.protected = 'true';
        gallery.addEventListener('dragstart', guard);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => protect());
    else protect();
    document.addEventListener('shopify:section:load', event => protect(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfa-press-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wire = (scope = document) => {
      scope.querySelectorAll('[data-bfa-band-toggle]').forEach(button => {
        if (button.dataset.wired) return;
        const wrap = button.closest('.bfa-press');
        const band = wrap ? wrap.querySelector('[data-bfa-band]') : null;
        const controls = button.closest('.bfa-band-controls');
        if (!band || !controls) return;
        button.dataset.wired = 'true';
        const label = button.querySelector('[data-bfa-band-label]');
        const pauseWord = button.dataset.labelPause || '';
        const playWord = button.dataset.labelPlay || '';
        const setState = playing => {
          band.setAttribute('data-bfa-band-playing', playing ? 'true' : 'false');
          button.setAttribute('aria-pressed', playing ? 'false' : 'true');
          if (label) label.textContent = playing ? pauseWord : playWord;
        };
        button.addEventListener('click', () => {
          setState(band.getAttribute('data-bfa-band-playing') === 'false');
        });
        setState(true);
        controls.setAttribute('data-bfa-band-ready', 'true');
      });

      scope.querySelectorAll('[data-reviews-band]').forEach(band => {
        if (band.dataset.wired) return;
        band.dataset.wired = 'true';
        const scroller = band.querySelector('[data-reviews-scroller]');
        if (!scroller) return;
        band.querySelectorAll('[data-reviews-step]').forEach(button => {
          button.addEventListener('click', () => {
            const item = scroller.querySelector('li');
            const gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;
            const step = item ? item.getBoundingClientRect().width + gap : scroller.clientWidth * 0.8;
            scroller.scrollBy({ left: step * Number(button.dataset.reviewsStep), behavior: 'smooth' });
          });
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => wire());
    else wire();
    document.addEventListener('shopify:section:load', event => wire(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfa-questions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wire = (scope = document) => {
      scope.querySelectorAll('[data-qp]').forEach(root => {
        if (root.dataset.wired) return;
        root.dataset.wired = 'true';

        const input = root.querySelector('[data-qp-input]');
        const clear = root.querySelector('[data-qp-clear]');
        const count = root.querySelector('[data-qp-count]');
        const empty = root.querySelector('[data-qp-empty]');
        const groups = [...root.querySelectorAll('[data-qp-group]')];
        const items = [...root.querySelectorAll('[data-qp-item]')];

        /* Read once. The answers are rich text and normalising them on every
           keystroke would be work for nothing. */
        const haystacks = items.map(item => item.textContent.toLowerCase().replace(/\s+/g, ' '));

        /* The wording for 0 matches comes from the section setting, read off
           the note once. The note itself never shows: the live region below
           carries that sentence, so the reader is told once rather than
           twice. Same shape as sections/bfa-faq.liquid. */
        const emptyNote = empty ? empty.textContent.trim() : '';

        /* Closes only what this script opened. A question the reader opened
           by hand carries no flag and is left exactly as they left it. */
        const closeIfAuto = item => {
          if (item.dataset.qpAutoOpen === '1') {
            item.open = false;
            delete item.dataset.qpAutoOpen;
          }
        };

        const apply = () => {
          const query = input ? input.value.trim().toLowerCase() : '';

          if (!query) {
            items.forEach(item => { item.hidden = false; closeIfAuto(item); });
            groups.forEach(group => { group.hidden = false; });
            root.removeAttribute('data-qp-searching');
            /* Emptied, never hidden. See the note in the stylesheet. */
            if (count) count.textContent = '';
            if (empty) empty.hidden = true;
            if (clear) clear.hidden = true;
            return;
          }

          root.setAttribute('data-qp-searching', 'true');
          if (clear) clear.hidden = false;

          let hits = 0;
          items.forEach((item, i) => {
            const match = haystacks[i].indexOf(query) !== -1;
            item.hidden = !match;
            if (match) {
              /* Open what matched, so the answer is on screen rather than 1
                 more click away once the reader has already told us what they
                 are looking for. Flagged, so it can be closed again when it
                 stops matching or when the box is cleared. */
              if (!item.open) {
                item.open = true;
                item.dataset.qpAutoOpen = '1';
              }
              hits++;
            } else {
              closeIfAuto(item);
            }
          });

          /* A heading with nothing under it reads as a broken group. */
          groups.forEach(group => {
            group.hidden = ![...group.querySelectorAll('[data-qp-item]')].some(item => !item.hidden);
          });

          if (count) {
            count.textContent = hits === 0
              ? emptyNote
              : (hits === 1
                ? '1 question matches'
                : hits + ' of ' + items.length + ' questions match');
          }
          if (empty) empty.hidden = true;
        };

        if (input) {
          input.addEventListener('input', apply);
          input.addEventListener('search', apply);
        }
        if (clear) {
          clear.addEventListener('click', () => {
            if (input) { input.value = ''; input.focus(); }
            apply();
          });
        }

        /* A link from a support reply lands on a closed answer otherwise.
           The id is built from the question text with the handle filter, so
           it survives the question being reordered but not reworded. */
        const openFromHash = () => {
          const hash = window.location.hash;
          if (!hash || hash.length < 2) return;
          let target = null;
          try { target = root.querySelector(hash); } catch (error) { return; }
          if (!target || !target.matches('[data-qp-item]')) return;
          target.open = true;
          target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        };
        openFromHash();
        window.addEventListener('hashchange', openFromHash);
      });
    };
    /* THE CONFIRMATION AND THE ERROR LIST DO NOT ANNOUNCE ON THEIR OWN.
       Both sit in the initial DOM of the page the browser lands on after
       the post, and a live region only announces what changes after it has
       registered, so neither ever spoke. The roles are gone from the
       markup and this moves focus to whichever region is on the page
       instead, which both announces it and puts the reader in front of it.
       The form is at the foot of 16 questions and 6 groups.

       The success region is looked for first and the error region second.
       This throws nothing when neither is there, which is every ordinary
       page load, and nothing here is attached to the form or to the submit
       button: the post itself has to work with scripting off. */
    const announce = () => {
      try {
        const region = document.querySelector('[data-qp-sent]') || document.querySelector('[data-qp-errors]');
        if (!region) return;
        region.focus();
        region.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } catch (error) {
        /* Nothing to move to, or a browser too old for the options bag. */
      }
    };
    const start = () => { wire(); announce(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', event => wire(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfa-store-header"]) return;
  try {
    
  (() => {
    /* 1 set of document level listeners for the whole page, bound the first
       time a header initializes and never again. The theme editor swaps in a
       brand new root on every save, and the guard below is per root, so the
       old code bound 2 more document listeners each time and neither was ever
       taken off. Each live root parks its closer in a WeakMap keyed by the
       root, so a root that leaves the page is collected along with it. */
    const closers = new WeakMap();
    let documentBound = false;
    const bindDocumentOnce = () => {
      if (documentBound) return;
      documentBound = true;
      document.addEventListener('pointerdown', event => {
        document.querySelectorAll('[data-bfa-store-header]').forEach(root => {
          const close = closers.get(root);
          if (close) close(event.target);
        });
      });
    };

    const initializeHeader = (scope = document) => {
      /* The :not([data-ready]) marker is the pattern snippets/bfa-script.liquid
         already uses, so this file now agrees with it. */
      scope.querySelectorAll('[data-bfa-store-header]:not([data-ready])').forEach(root => {
        root.dataset.ready = 'true';
        const toggle = root.querySelector('[data-store-menu-toggle]');
        const dropdowns = [...root.querySelectorAll('.bfa-store-dropdown')];
        /* September 22, 2026. The Atelier banner is 3 flat links now, so the
           toggle, the Escape handler, the outside closer, the focusout closer
           and the arrow key roving that drove its list are all gone. What is
           left below belongs to the masthead above it and to nothing else. */
        const closeDropdowns = () => {
          dropdowns.forEach(menu => { menu.open = false; });
        };
        const closeMobile = () => {
          root.dataset.menuOpen = 'false';
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          closeDropdowns();
        };
        if (toggle) toggle.addEventListener('click', () => {
          const open = root.dataset.menuOpen !== 'true';
          root.dataset.menuOpen = String(open);
          toggle.setAttribute('aria-expanded', String(open));
          if (!open) closeDropdowns();
        });
        dropdowns.forEach(menu => {
          let leaveTimer;
          /* A menu whose parent link is missing is still a working details. */
          const parentLink = menu.querySelector('[data-store-parent-link]');
          if (parentLink) parentLink.addEventListener('click', event => {
            if (window.matchMedia('(max-width: 949px)').matches && !menu.open) {
              event.preventDefault();
              menu.open = true;
            }
          });
          menu.addEventListener('toggle', () => {
            if (menu.open) dropdowns.forEach(other => { if (other !== menu) other.open = false; });
          });
          menu.addEventListener('pointerenter', () => {
            clearTimeout(leaveTimer);
            if (window.matchMedia('(hover: hover) and (min-width: 950px)').matches) menu.open = true;
          });
          menu.addEventListener('pointerleave', () => {
            if (window.matchMedia('(hover: hover) and (min-width: 950px)').matches) leaveTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 200);
          });
        });

        root.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const openMenu = dropdowns.find(menu => menu.open);
          if (openMenu) {
            closeDropdowns();
            /* A details with no summary cannot be focused, and asking for one
               that is not there used to throw on the way out of the menu. */
            const openSummary = openMenu.querySelector('summary');
            if (openSummary) openSummary.focus();
          } else if (root.dataset.menuOpen === 'true') {
            closeMobile();
            if (toggle) toggle.focus();
          }
        });
        root.querySelectorAll('a').forEach(link => link.addEventListener('click', event => { if (!event.defaultPrevented) closeMobile(); }));

        /* The 1 place the shared document listener calls back into this root. */
        closers.set(root, target => {
          if (!root.contains(target)) closeMobile();
        });
        bindDocumentOnce();

        /* root is the shell, and the offer bar is inside it, so the measured
           height is the height of everything that sticks. */
        const measureHeader = () => document.documentElement.style.setProperty('--bfa-store-header-height', `${Math.ceil(root.getBoundingClientRect().height)}px`);
        measureHeader();
        if (typeof ResizeObserver === 'function') new ResizeObserver(measureHeader).observe(root);
        /* addEventListener on a MediaQueryList landed in Safari 14. Before
           that it is addListener, and calling the newer 1 threw a TypeError
           that took the rest of this function down with it. Guarded the way
           snippets/bfa-canvas-filters.liquid guards it. */
        const wide = window.matchMedia('(min-width: 950px)');
        if (typeof wide.addEventListener === 'function') wide.addEventListener('change', closeMobile);
        else if (typeof wide.addListener === 'function') wide.addListener(closeMobile);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeHeader());
    else initializeHeader();
    document.addEventListener('shopify:section:load', event => initializeHeader(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
